import React from 'react'
import style from "../Cards/Cards.module.css";


const Cards = ({ imgUrl, title, description }) => {
  return (
    <div className={style.cards}>
      <img className={style.cards__img} src={imgUrl} alt="err" />
      <div className={style.title}>
        {title}
      </div>
      <div className={style.description}>
        {description}
      </div>
    </div>
  )
}

export default Cards